export function checkValueInEnum<T>(value: unknown, obj: T): value is T {
  return typeof value === 'string' && value in obj;
}
